import React, { useState } from "react";
import axios from "axios";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import "./EmployeesPage.scss";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
} from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { GiTakeMyMoney } from "react-icons/gi";
import DataGridServerSide from "../../Components/DataGridServerSide";
import CrudPageHeader from "../../Components/CrudPageHeader";
import useAccountsGridData from "../../hooks/useAccountsGridData";
import EmployeesModal from "./EmployeesModal";
import EmployeesViewModal from "./EmployeesViewModal";
import { useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";

export default function EmployeesPage() {
  const headers = authHeader();
  const history = useHistory();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [viewEmployee, setViewEmployee] = useState(null);

  const getApiErrorMessage = (error, fallbackMessage) => {
    if (error?.response?.data?.errorMessage) {
      return `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`;
    }

    if (
      typeof error?.response?.data === "string" &&
      error.response.data.trim() !== ""
    ) {
      return error.response.data;
    }

    if (error?.message) {
      return `Gabim: ${error.message}`;
    }

    return fallbackMessage;
  };

  const {
    loading,
    data,
    rowCount,
    paginationModel,
    setPaginationModel,
    sortModel,
    setSortModel,
    filterModel,
    setFilterModel,
    quickFilter,
    setQuickFilter,
    fetchData,
  } = useAccountsGridData({
    headers,
    ledgerID: 310,
    onError: (error) =>
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim i panjohur në marrjen e punonjësve.",
        ),
      ),
  });

  const handleEdit = async (item) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + `Accounts/getAccountForEdit/${item.AccountID}`,
        { headers },
      );

      setSelectedEmployee(response.data);
      setShowEditModal(true);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim në marrjen e të dhënave të punonjësit për editim.",
        ),
      );
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedEmployee(null);
  };

  const handleView = async (item) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + `Accounts/getAccountForEdit/${item.AccountID}`,
        { headers },
      );

      setViewEmployee(response.data);
      setShowViewModal(true);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim në marrjen e të dhënave të punonjësit për shikim.",
        ),
      );
    }
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewEmployee(null);
  };

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "Accounts" + `/${deleteItemId}`,
        {
          headers,
        },
      );

      const result = response.data;
      if (result.success) {
        handleSuccess("Punonjësi është fshirë me sukses");
        fetchData();
      } else {
        deleteAlert(
          "Punonjësi nuk mund të fshihet sepse është përdorur në transaksione",
        );
      }
    } catch (error) {
      deleteAlert("Ka ndodhur një gabim gjatë fshirjes së punonjësit.");
    }
  };

  const employeesGridHeader = [
    {
      field: "id",
      headerName: "#",
      width: 60,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      groupable: false,
      aggregable: false,
    },
    {
      field: "AccountName",
      headerName: "Emri i Punonjësit",
      flex: 2.3,
      minWidth: 280,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "IdentificationNumber",
      headerName: "Numri Identifikues",
      flex: 1.1,
      minWidth: 170,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "Adress",
      headerName: "Adresa",
      flex: 1.4,
      minWidth: 200,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "IsActive",
      headerName: "Aktiv",
      width: 90,
      headerClassName: "super-app-theme--header",
      renderCell: (params) =>
        params.value ? (
          <CheckCircleOutlineIcon style={{ color: "green" }} />
        ) : (
          ""
        ),
    },
    {
      field: "contracts",
      headerName: "Kontratat",
      width: 110,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      groupable: false,
      aggregable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() =>
            history.push(`/employees/contracts/${params.row.rowInfo.AccountID}`)
          }
        >
          <AssignmentIcon />
        </IconButton>
      ),
    },
  ];

  const rows = data.map((item, index) => ({
    id: paginationModel.page * paginationModel.pageSize + index + 1,
    AccountName: item.AccountName,
    IdentificationNumber: item.IdentificationNumber,
    Adress: item.Adress ?? "",
    IsActive: Boolean(item.IsActive),
    deleteItemId: item.AccountID,
    rowInfo: item,
  }));

  return (
    <div className="Crud__Container employees-page__container">
      <EmployeesModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        mode="edit"
        initialData={selectedEmployee}
        fetchData={fetchData}
      />

      <EmployeesViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        employeeData={viewEmployee}
      />

      <CrudPageHeader
        icon={GiTakeMyMoney}
        title="Lista e Punonjësve"
        description="Forma e Punonjësve: Menaxhoni, shtoni, editoni dhe fshini Punonjës."
        tutorialUrl="https://www.youtube.com/@Accountree"
        tutorialLabel="Shiko Tutorialin"
        action={<EmployeesModal fetchData={fetchData} type="text" />}
        className="employees-page__header"
      />

      <DataGridServerSide
        columns={employeesGridHeader}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleShowPrint={handleView}
        showPayment={false}
        height={500}
        rowCount={rowCount}
        loading={loading}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        sortModel={sortModel}
        setSortModel={setSortModel}
        filterModel={filterModel}
        setFilterModel={setFilterModel}
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
        showDetailsStatus={true}
      />
    </div>
  );
}
